import { useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import ProgressBar from 'react-bootstrap/ProgressBar';
import CboSeccion from './CboSeccion';
import CboPeriodos from "./CboPeriodos";
import CboTipoLiq from "./CboTipoLiq";
import CboGrupo from "./CboGrupo";
import CboEmpresa from "./CboEmpresa";


var intSeccion = 0;
var intTipoLiq = 0;
var intPeriodo = 0;

const Liquidacion = (props) => {

  const [progreso, setProgreso] = useState(0)
  const [lugar, setLugar] = useState(0)
  const [total, setTotal] = useState(0)
  const [estaProcesando, setEstaProcesando] = useState(false);

  const [grupo, setGrupo] = useState(0)
  const [gruusu, setGruusu] = useState(0)
  const [empresa, setEmpresa] = useState(0)
  const [seccion, setSeccion] = useState(0)
  const [tipoliq, setTipoLiq] = useState(0)
  const [periodoLiq, setPeriodoLiq] = useState(0)

  const [msjCantAl, setMsjCantAl] = useState("");
  const [msjCantP, setMsjCantP] = useState("");
  const [msjCantF, setMsjCantF] = useState("");
  const [cantAl, setCantAl] = useState(0);
  const [cantP, setCantP] = useState(0);
  const [cantF, setCantF] = useState(0);
  const [cambioResu, setCambioResu] = useState(false);

  const [activo, setActivo] = useState(false)
  const [noteditable, setNotEditable] = useState(false)

  // ventana de búsqueda
  const [vermodal, setVermodal] = useState(false)


  // ventana de confirmación
  const [vermodalconf, setVermodalConf] = useState(false)

  // toast
  const [showToast, setShowToast] = useState(false);
  const [textoToast, setTextoToast] = useState("");


  async function handleArchPago(e) {

    var json3;
    var jsons3;
    var url3;
    let consulta = new Object();


    consulta.grupo = grupo;
    consulta.empresa = empresa;
    consulta.seccion = seccion;
    consulta.tipoliq = tipoliq;
    consulta.periodo = periodoLiq;

    jsons3 = JSON.stringify(consulta);


    var options3 = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'

      },
      mode: 'cors',
      credential: 'include',
      body: jsons3,

    };

    url3 = `${process.env.REACT_APP_API_URL}/liq/archpagoauto`;



    fetch(url3, options3)
      .then(response => response.json())
      .then(data => {

        json3 = data;
        console.log("resumen=>", json3);
        // si hay datos, cargar en la ficha el primero
        setMsjCantAl("Alumnos disponibles: " + json3.cantAl);
        setMsjCantP(" Alumnos liquidados: " + json3.cantP);
        setMsjCantF(" Alumnos facturados: " + json3.cantF);
        setCantAl(json3.cantAl);
        setCantP(json3.cantP);
        setCantF(json3.cantF);


      })



  }





  const handleGrupoChange = (event) => {

    // por ahora el Grupo es único para un usuario
    setGrupo(event.target.value);
  };

  const handleEmpresaChange = (event) => {
    setEmpresa(event.target.value);
  };

  const handleSeccionChange = (event) => {
    console.log("Seccion", event.target.value);
    setSeccion(event.target.value);
    //intSeccion = event.target.value;

    //refreshResu();
  };
  const handleTipoLiqChange = (event) => {
    console.log("TipoLiq: ", event.target.value);
    setTipoLiq(event.target.value);
    //intTipoLiq = event.target.value;

    // refreshResu();
  };
  const handlePeriodoLiqChange = (event) => {
    setPeriodoLiq(event.target.value);
    //intPeriodo = event.target.value;

    // refreshResu();
  };
  const location = useLocation();
  useEffect(() => {

    setGrupo(props.grupo);
    setGruusu(props.grusu);

    /*
       var { laseccion } = location.seccion || {};
        
        
    
        if (laseccion)
          {
             setSeccion(laseccion);
          }
          */

    setMsjCantAl(""); setMsjCantP(""); setMsjCantF("");
    if (seccion && tipoliq && periodoLiq) {

      var json3;
      var jsons3;
      var url3;
      let consulta = new Object();


      consulta.grupo = grupo;
      consulta.empresa = empresa;
      consulta.seccion = seccion;
      consulta.tipoliq = tipoliq;
      consulta.periodo = periodoLiq;

      jsons3 = JSON.stringify(consulta);


      var options3 = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'

        },
        mode: 'cors',
        credential: 'include',
        body: jsons3,

      };

      url3 = `${process.env.REACT_APP_API_URL}/liq/resuliq`;



      fetch(url3, options3)
        .then(response => response.json())
        .then(data => {

          json3 = data;
          console.log("resumen=>", json3);
          // si hay datos, cargar en la ficha el primero
          setMsjCantAl("Alumnos disponibles: " + json3.cantAl);
          setMsjCantP(" Alumnos liquidados: " + json3.cantP);
          setMsjCantF(" Alumnos facturados: " + json3.cantF);
          setCantAl(json3.cantAl);
          setCantP(json3.cantP);
          setCantF(json3.cantF);


        })



    }

  }, [seccion, tipoliq, periodoLiq, cambioResu])

  /* Handle de evento modelo */
  async function handleModel(e) {
    e.preventDefault()
    try {
      var json = ""
    } catch (error) {
      console.log(error);

    }
  }

  async function handleFacturar(e) {

    //// 1) Obtener cantidad a Facturar
    setEstaProcesando(true);
    var intProcesando = true;
    var json1in, json1out;
    var url3;
    let laLiq = new Object();
    // total de registros a procesar

    // lugar del progreso

    laLiq.grupo = props.grupo;
    laLiq.empresa = empresa;
    laLiq.seccion = seccion;

    json1in = JSON.stringify(laLiq);


    var options3 = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'

      },
      mode: 'cors',
      credential: 'include',
      body: json1in,

    };

    url3 = `${process.env.REACT_APP_API_URL}/liq/liquidados`;



    fetch(url3, options3)
      .then(response => response.json())
      .then(data => {

        json1out = data.data;
        console.log("cantidad a facturar", json1out[0].cant);
        setTotal(json1out[0].cant);

      })




    /// 2) lanzar el procesamiento de la facturación
    setProgreso(0);

    let unLiq = new Object();

    /* en principio no los necesito
       unLiq.grupo = props.grupo;
       unLiq.empresa = empresa;
    */
    unLiq.seccion = seccion;
    unLiq.tipoliq = tipoliq;
    unLiq.periodo = periodoLiq;
    var url;
    var json2in, json2out;
    // indico el comienzo del procesamiento

    e.preventDefault()
    try {

      json2in = JSON.stringify(unLiq);
      console.log(json2in);

      url = `${process.env.REACT_APP_API_URL}/liq/factliq`;


      var options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'cors',
        credential: 'include',
        body: json2in,

      };

      fetch(url, options)
        .then(response => response.json())
        .then(data => {

          json2out = data;
          console.log("finalizar", json2out);

        }).finally(() => {
          setEstaProcesando(false);
          intProcesando = false;
          setProgreso(100);

        })
    } catch (error) {
      console.log(error);

    }

    /// 3) lanzar control de progreso

    var json3in, json3out;
    var url1;

    let progLiq = new Object();
    progLiq.seccion = seccion;
    progLiq.tipoliq = tipoliq;
    progLiq.periodo = periodoLiq;


    json3in = JSON.stringify(progLiq);
    var vueltas = 0;
    var options2 = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'

      },
      mode: 'cors',
      credential: 'include',
      body: json3in,

    };


    url1 = `${process.env.REACT_APP_API_URL}/liq/progfact`;


    console.log("vta ", intProcesando, vueltas);
    while (intProcesando) {
      console.log("vta ", vueltas++);
      await new Promise(resolve => setTimeout(resolve, 1000));




      fetch(url1, options2)
        .then(response => response.json())
        .then(data => {

          json3out = data;
          console.log("progr", json3out[0].cant);
          setLugar(json3out[0].cant);

          //setProgreso(Math.trunc((lugar/total) * 100));

        })
    }
    //refreshResu();
    setCambioResu(!cambioResu);
  }


  /// eliminar la info de una liquidación que aun no fue facturada
  async function handleLiqElim(e) {

    var json3in, json3out;
    var url1;

    let progLiq = new Object();
    progLiq.seccion = seccion;
    progLiq.tipoliq = tipoliq;
    progLiq.periodo = periodoLiq;


    json3in = JSON.stringify(progLiq);
    var vueltas = 0;
    var options2 = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'

      },
      mode: 'cors',
      credential: 'include',
      body: json3in,

    };


    url1 = `${process.env.REACT_APP_API_URL}/liq/delliq`;



    fetch(url1, options2)
      .then(response => response.json())
      .then(data => {

        json3out = data.data;
        console.log("eliminado ", json3out);
        setCambioResu(!cambioResu);
        //setProgreso(Math.trunc((lugar/total) * 100));

      })


  }



  async function handleLiqProc(e) {
    //// 1) Obtener cantidad a liquidar
    setEstaProcesando(true);
    var intProcesando = true;
    var json1in, json1out;
    var url3;
    let laLiq = new Object();
    // total de registros a procesar

    // lugar del progreso

    laLiq.grupo = props.grupo;
    laLiq.empresa = empresa;
    laLiq.seccion = seccion;

    json1in = JSON.stringify(laLiq);


    var options3 = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'

      },
      mode: 'cors',
      credential: 'include',
      body: json1in,

    };

    url3 = `${process.env.REACT_APP_API_URL}/alu/getalumliqcant`;



    fetch(url3, options3)
      .then(response => response.json())
      .then(data => {

        json1out = data.data;
        console.log("cantidad a procesar", json1out[0].cant);
        setTotal(json1out[0].cant);

      })




    /// 2) lanzar el procesamiento de la liquidación
    setProgreso(0);

    let unLiq = new Object();

    unLiq.grupo = props.grupo;
    unLiq.empresa = empresa;
    unLiq.seccion = seccion;
    unLiq.tipoliq = tipoliq;
    unLiq.periodo = periodoLiq;
    var url;
    var json2in, json2out;
    // indico el comienzo del procesamiento

    e.preventDefault()
    try {

      json2in = JSON.stringify(unLiq);
      console.log(json2in);

      url = `${process.env.REACT_APP_API_URL}/liq/runliq`;


      var options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'cors',
        credential: 'include',
        body: json2in,

      };

      fetch(url, options)
        .then(response => response.json())
        .then(data => {

          json2out = data;
          console.log("finalizar", json2out);

        }).finally(() => {
          setEstaProcesando(false);
          intProcesando = false;
          setProgreso(100);

        })
    } catch (error) {
      console.log(error);

    }

    /// 3) lanzar control de progreso

    var json3in, json3out;
    var url1;

    let progLiq = new Object();
    progLiq.seccion = seccion;
    progLiq.tipoliq = tipoliq;
    progLiq.periodo = periodoLiq;


    json3in = JSON.stringify(progLiq);
    var vueltas = 0;
    var options2 = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'

      },
      mode: 'cors',
      credential: 'include',
      body: json3in,

    };


    url1 = `${process.env.REACT_APP_API_URL}/liq/progliq`;


    console.log("vta ", intProcesando, vueltas);
    while (intProcesando) {
      console.log("vta ", vueltas++);
      await new Promise(resolve => setTimeout(resolve, 1000));




      fetch(url1, options2)
        .then(response => response.json())
        .then(data => {

          json3out = data;
          console.log("progr", json3out[0].cant);
          setLugar(json3out[0].cant);

          //setProgreso(Math.trunc((lugar/total) * 100));

        })
    }
    //refreshResu();
    setCambioResu(!cambioResu);
  }




  return (
    <div >

      <div className="container-fluid">
        <h3>Procesar Liquidación</h3>

        <form>
          <div className="row">
            <CboGrupo
              selectedValue={grupo}
              onChange={handleGrupoChange}
              disabled={true}
              grusu={gruusu}
            />

            <CboEmpresa
              selectedValue={empresa}
              onChange={handleEmpresaChange}
              disabled={true}
              grupo={grupo}
              grusu={gruusu}
            />

            <CboSeccion
              selectedValue={seccion}
              onChange={handleSeccionChange}
              disabled={noteditable}
              grupo={grupo}
              empresa={empresa}
            />

            <CboTipoLiq
              selectedValue={tipoliq}
              onChange={handleTipoLiqChange}
              disabled={noteditable}

            />

            <CboPeriodos
              selectedValue={periodoLiq}
              onChange={handlePeriodoLiqChange}
              disabled={noteditable}

              grupo={grupo}
              empresa={empresa}
              tipoliq={tipoliq}
            />

            <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-6">
              <div className="form-group success ">
                <label className="text-success" htmlFor="exampleInputEmail1">{msjCantAl}</label>
                <label className="text-success" htmlFor="exampleInputEmail1">{msjCantP}</label>
                <label className="text-success" htmlFor="exampleInputEmail1">{msjCantF}</label>

              </div>
            </div>

          </div>
        </form>



        <div className="row mb-1 border-primary acciones-liquidacion">



          <div className="col  col-1 text-center border-info">
            <button type="button" className="filtrar" id="clear" onClick={handleLiqProc} disabled={!(cantAl && ((cantAl - cantP) > 0))} >Liquidar</button>
          </div>
          <div className="col  col-1 text-center border-info">
            <button type="button" className="filtrar" id="clear" onClick={handleLiqElim} disabled={(cantAl && ((cantAl - cantP) > 0))} >Eliminar</button>
          </div>
          <div className="col  col-1 text-center border-info">
            <button type="button" className="filtrar" id="clear" onClick={handleFacturar} disabled={!(cantAl && cantP)} >Facturar</button>
          </div>
          <div className="col  col-1 text-center border-info">
            <button type="button" className="filtrar" id="clear" onClick={handleArchPago} disabled={!(cantF)} >Arch Cobrar</button>
          </div>
          <div className={estaProcesando ? "col  col-1 text-center border-primary" : "col  col-1 text-center border-primary d-none"}>
            <label htmlFor="exampleInputEmail1">{lugar}/{total}</label>
          </div>

          <div className={estaProcesando ? "col  col-7 text-center border-primary" : "col  col-7 text-center border-primary d-none"}>
            <ProgressBar now={Math.trunc((lugar / total) * 100)} />

          </div>

        </div>





        <ToastContainer position="bottom-end">
          <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide>

            <Toast.Body>{textoToast}</Toast.Body>
          </Toast>
        </ToastContainer>










        <div className="toast-container position-fixed bottom-0 end-0 p-3">
          <div id="liveToastmsg" className="toast" role="alert" aria-live="assertive" aria-atomic="true">

            <div className="toast-body">

            </div>
          </div>
        </div>











      </div>

    </div>
  );
};

export default Liquidacion;

